import { Transition } from '@headlessui/react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <nav className='bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-b border-gray-800'>
      <div className='max-w-6xl container mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex items-center justify-between h-16'>
          <div className='flex items-center'>
            <Link to='/' className='text-white font-semibold text-lg'>
              CloudSoft
            </Link>
            <div className='hidden md:block'>
              <div className='ml-10 flex items-baseline space-x-4'>
                <Link
                  to='/services'
                  className='text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium'
                >
                  Services
                </Link>

                <Link
                  to='/portfolio'
                  className='text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium'
                >
                  Portfolio
                </Link>

                <Link to='/posts' className='text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium'>
                  Blog
                </Link>

                <Link to='/company' className='text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium'>
                  Company
                </Link>

                <Link to='/contact' className='text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium'>
                  Contact
                </Link>
              </div>
            </div>
          </div>
          <div className='-mr-2 flex md:hidden'>
            <button
              onClick={() => setIsOpen(!isOpen)}
              type='button'
              className='bg-gray-900 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white'
              aria-controls='mobile-menu'
              aria-expanded='false'
            >
              <span className='sr-only'>Open main menu</span>
              {!isOpen ? (
                <svg
                  className='block h-6 w-6'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  aria-hidden='true'
                >
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16M4 18h16' />
                </svg>
              ) : (
                <svg
                  className='block h-6 w-6'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  aria-hidden='true'
                >
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter='transition ease-out duration-100 transform'
        enterFrom='opacity-0 scale-95'
        enterTo='opacity-100 scale-100'
        leave='transition ease-in duration-75 transform'
        leaveFrom='opacity-100 scale-100'
        leaveTo='opacity-0 scale-95'
      >
        <div className='md:hidden' id='mobile-menu'>
          <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
            <Link
              to='/services'
              className='hover:bg-gray-700 text-white block px-3 py-2 rounded-md text-base font-medium'
            >
              Services
            </Link>

            <Link
              to='/portfolio'
              className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
            >
              Portfolio
            </Link>

            <Link
              to='/posts'
              className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
            >
              Blog
            </Link>

            <Link
              to='/company'
              className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
            >
              Company
            </Link>

            <Link
              to='/contact'
              className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
            >
              Contact
            </Link>
          </div>
        </div>
      </Transition>
    </nav>
  )
}

export default Nav
